import { useState } from 'react';
import { InvoiceListItem } from '../../../../redux/accounting/definitions';
import StateCode from '../../../../types/Invoices/StateCode';

interface RollbackModalData {
  view: boolean;
  invoice_id: number;
  stateCode: StateCode;
  reference_number: string;
  entity_name: string;
}

type UseRollbackInvoiceModalModal = {
  rollabackModal: RollbackModalData;
  closeRollbackModal: () => void;
  openRollbackModal: (rowData: InvoiceListItem) => void;
};

const useRollbackInvoiceModal = (): UseRollbackInvoiceModalModal => {
  const defaultValues = {
    view: false,
    invoice_id: 0,
    stateCode: StateCode.pagada(),
    reference_number: '',
    entity_name: '',
  };

  const [rollabackModal, setRollabackModal] = useState<RollbackModalData>(defaultValues);

  const closeRollbackModal = () => {
    setRollabackModal(defaultValues);
  };

  const openRollbackModal = (rowData: InvoiceListItem) => {
    setRollabackModal({
      view: true,
      invoice_id: rowData.id,
      entity_name: rowData.entity_name,
      stateCode: new StateCode(rowData.state_code),
      reference_number: rowData.reference_number,
    });
  };

  return {
    rollabackModal,
    closeRollbackModal,
    openRollbackModal,
  };
};

export default useRollbackInvoiceModal;
